<template>
	<div class="content-page content-page--logos">
		<CustomerNav />
		<div class="content-page__heading">
			<div class="content-page__breadcrumb-title">
				<Breadcrumbs :items="urlNames" />
				<h2 class="content-page__title">Logos</h2>
			</div>
			<div class="content-page__actions">
				<Button
					className="btn--has-icon"
					iconClassName="icon-history"
					:btnClick="() => {}"
					:iconBeforeLabel="true"
					labelText="History"
					id="displayLogoHistory"
				/>
			</div>
		</div>
		<div class="results-toolbar results-toolbar--search">
			<div class="results-toolbar__search">
				<!--DEV NOTE: Component is pending development's implemention. This dropdown doesn't have a title or helper text -->
				<Dropdown />
			</div>
		</div>
		<LogosList />
	</div>
</template>

<script>
import Breadcrumbs from '@/components/shells/breadcrumbs/breadcrumbs';
import Button from '@/components/forms/button/button';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import LogosList from './logo-list';
import CustomerNav from '@/sections/shared/customer-navegation';

export default {
	name: 'Logos',
	components: {
		Breadcrumbs,
		Button,
		Dropdown,
		LogosList,
		CustomerNav
	},
	data() {
		return {
			urlNames: [{ url: 'clients', name: 'Clients' }]
		};
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Logo Manager Screen
    * Can use SCSS variables = TRUE
 */
</style>
